/**
 * Created by andromeda on 5/5/2017.
 */


export default class tdLocalStorage {



    static _isAvailableFlag = null;

    static _isAvailable() {



        if (this._isAvailableFlag === null) {
            try {
                let storage = window['localStorage'];
                let test = '__storage_test__';
                storage.setItem(test, test);
                storage.removeItem(test);
                this._isAvailableFlag = true;
                return true;

            }
            catch(e) {
                this._isAvailableFlag = false;
                console.log('localStorage not available');
                return false;
            }
        } else {

            return this._isAvailableFlag;
        }


    }




    static set(key, value) {
        if (this._isAvailable() === true) {
            localStorage.setItem(key, JSON.stringify(value));
        }
    }


    /**
     *
     * @param key
     * @returns {null} returns null if it's not set
     */
    static get(key) {
        if (this._isAvailable() === true) {
            try {
                let parsedObject = JSON.parse(localStorage.getItem(key));
                return JSON.parse(localStorage.getItem(key));
            } catch (e) {
                return null;
            }


        }
    }


    static delete(key) {
        if (this._isAvailable() === true) {
            localStorage.removeItem(key);
        }
    }





}



// WEBPACK FOOTER //
// ./src/tdLocalStorage.js